import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import FileUploadProductB from "./FileUploadProductB";
import { Header } from "./components/Header";
import Footer from "./components/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import ProductB from "./components/ProductB";
import axios from "axios";
import { NavLink } from "react-router-dom";

const Productb = () => {
  const [items, setItems] = useState([]);

  const API_URL = "https://atlas.docauto.riverchain.xyz/api";

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/sitesb`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched product B Data:", data?.isheet?.data?.item);
      setItems(data?.isheet?.data?.item);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleDeleteProductB = async (index, onUploadSuccess) => {
    console.log(index);
    try {
      const response = await axios.delete(`${API_URL}/deleteProductB/${index}`);
      console.log("Item deleted successfully:", response.data);
      onUploadSuccess();
    } catch (error) {
      console.error(
        "Error deleting item:",
        error.response?.data || error.message
      );
      alert("Failed to delete item.");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="container-fluid">
      <Header />

      <div className="row" style={{ marginTop: "30px" }}>
        <div className="col-md-6">
          <NavLink
            to="/producta"
            className={({ isActive }) =>
              `btn btn-lg ${isActive ? "btn-dark" : "btn-outline-secondary"}`
            }
          >
            Product A
          </NavLink>

          <NavLink
            to="/productb"
            className={({ isActive }) =>
              `btn btn-lg ${
                isActive ? "btn-dark" : "btn-outline-secondary"
              } ms-2`
            }
          >
            Product B
          </NavLink>

          {/* <NavLink
            to="/productc"
            className={({ isActive }) =>
              `btn btn-lg ${
                isActive ? "btn-dark" : "btn-outline-secondary"
              } ms-2`
            }
          >
            Product C
          </NavLink> */}
        </div>
      </div>

      <div className="row" style={{ background: "#fefefe" }}>
        <div className="col-md-4">
          <FileUploadProductB onUploadSuccess={fetchData} />
        </div>

        <div className="col-md-8">
          <ProductB
            items={items}
            handleDeleteProductB={handleDeleteProductB}
            onUploadSuccess={fetchData}
          />
        </div>
      </div>
    </div>
  );
};

export default Productb;
